import { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as LNIcon } from '../../../assets/img/ln.svg';
import { ReactComponent as PPIcon } from '../../../assets/img/pp.svg';
import { ReactComponent as RRPIcon } from '../../../assets/img/rrp.svg';
import { ReactComponent as CGVIcon } from '../../../assets/img/cgv.svg';
import AccessModal from '../../../components/Modal/AccessModal.jsx';
import { useTranslation } from 'react-i18next';
import useAccessType from '../../../hooks/useAccessType.js';

function TermsScreen() {
    const navigate = useNavigate();
    const [modalType, setModalType] = useState(null);
    const { t } = useTranslation();
    const {getAccessType} = useAccessType(true);
    const [modalShow, setModalShow] = useState(false);

    const handleModuleClick = (path) => {
        const accessType = getAccessType();
        if (!accessType) {
            navigate(path);
        } else {
            setModalType(accessType);
            setModalShow(true);
        }
    };

    const modules = [
        { id: 1, label: 'legal.terms', path: '/terms/legal', icon: LNIcon },
        { id: 2, label: 'legal.cgv', path: '/terms/cgv', icon: CGVIcon }
    ];

    const modules2 = [
        { id: 3, label: 'legal.pp', path: '/terms/pp', icon: PPIcon },
        { id: 4, label: 'legal.rrp', path: '/terms/rrp', icon: RRPIcon }
    ];

    return (
        <Container className="py-5">
            <Row className="mb-5">
                <Col xs={12} className="text-center">
                    <h2 className="title">{t('legal.whatDoYouNeed')}</h2>
                </Col>
            </Row>

            <Row className="mb-4 g-4 justify-content-center">
                {modules.map((module) => {
                    const IconComponent = module.icon;
                    return (
                        <Col key={module.id} xs={12} md={6} className="card-custom-container">
                            <div
                                className="card-custom-content d-flex align-items-center justify-content-center flex-column text-center"
                                onClick={() => handleModuleClick(module.path)}
                                role="button"
                                style={{ aspectRatio: '1 / 1', overflow: 'hidden' }}
                            >
                                <IconComponent className="mb-3 card-svg" />
                                <h3 className="card-title text-capitalize">
                                    {t(module.label)}
                                </h3>
                            </div>
                        </Col>
                    );
                })}
            </Row>

            <Row className="mb-4 g-4 justify-content-center">
                {modules2.map((module) => {
                    const IconComponent = module.icon;
                    return (
                        <Col key={module.id} xs={12} md={6} className="card-custom-container">
                            <div
                                className="card-custom-content d-flex align-items-center justify-content-center flex-column text-center"
                                onClick={() => handleModuleClick(module.path)}
                                role="button"
                                style={{ aspectRatio: '1 / 1', overflow: 'hidden' }}
                            >
                                <IconComponent className="mb-3 card-svg" />
                                <h3 className="card-title text-capitalize">
                                    {t(module.label)}
                                </h3>
                            </div>
                        </Col>
                    );
                })}
            </Row>

            <AccessModal
                show={modalShow}
                setShow={setModalShow}
                modalType={modalType}
            />
        </Container>
    );
}

export default TermsScreen;
